import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClientsSocisService } from '../../services/clients_socis/clientsSocis.service';
import { ListClientsSocisService } from '../list.service';

import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'mcrit-gestio-clientssocis-filters',
  templateUrl: './clientssocis-filters.component.html',
  styleUrls: ['./clientssocis-filters.component.css'],
  providers: [ClientsSocisService, ListClientsSocisService]
})
export class ClientsSocisFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;

  constructor(public translate: TranslateService, public languageService: LanguageService, private listClientsSocisService: ListClientsSocisService,private clientsSocisService: ClientsSocisService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.listClientsSocisService.valFiltres={};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listClientsSocisService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.listClientsSocisService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    const newFilter = {};
    if(this.filterModel.length > -1)
        for (let key of this.filterModel)newFilter[key] = null;
    this.listClientsSocisService.valFiltres={};
    //Inicialitza els checkboxes a l'estat inicial.
    this.listClientsSocisService.activeFilters = { client: true, soci: true }
    this.filterModel = this.listClientsSocisService.activeFilters;
    this.sendActiveFilters();
  }

  ngOnInit() {

    let requestedAutocompletes = [];

      this.filterModel = this.validFilters.reduce((acum, curr) => {
          curr.inputs.forEach(inputGroup => {
            switch (inputGroup.type) {
              case 'select':
                acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
                break;
              default:
              inputGroup.values.forEach(input => {
                if (input.autocomplete) {
                  requestedAutocompletes.push(input.autocomplete);
                }
                acum[input.name] = (input.value ? input.value : null);
              });
            }
          });

        return acum;
      }, {});

      this.dataLists = requestedAutocompletes.map(id => {
        return {
          id: id,
          options: this.clientsSocisService.getAutocomplete(id)
        };
      });
    this.sendActiveFilters();

  }

}
